import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  arrayMove,
  SortableContainer,
  SortableElement,
} from 'react-sortable-hoc';

import './PeerRanking.scss';

const SortableItem = SortableElement(({ value }) => (
  <li
    style={{
      border: '1px solid gray',
      background: '#232D4B',
      color: '#fff',
      padding: 10,
    }}
  >
    {value}
  </li>
));

const SortableList = SortableContainer(({ countries }) => {
  return (
    <ul className="rankingList">
      {countries.map((value, index) => (
        <span className="flex flex-items-center" key={`item-${index}`}>
          {index + 1}
          <SortableItem index={index} value={value} />
        </span>
      ))}
    </ul>
  );
});

class PeerRanking extends Component {
  constructor(props) {
    super(props);

    this.state = {
      countries: props.countries,
    };
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    this.setState({
      countries: arrayMove(this.state.countries, oldIndex, newIndex),
    });
  };

  onSubmitRankings = (e) => {
    e.preventDefault();

    this.props.submitRankings(this.state.countries);
  };

  shouldComponentUpdate = (nextProps) => {
    if (this.state.countries.length < 1 && nextProps.countries.length > 0) {
      this.setState(() => ({
        countries: nextProps.countries,
      }));
    }
    return true;
  };

  render() {
    const { requestSent } = this.props;
    return (
      <Fragment>
        <SortableList
          countries={this.state.countries}
          onSortEnd={this.onSortEnd}
        />
        <button
          type="button"
          className="loginBtn button"
          disabled={requestSent ? 'disabled' : ''}
          onClick={this.onSubmitRankings}
        >
          {requestSent ? 'Submitting . . .' : 'Submit Ranking'}
        </button>
      </Fragment>
    );
  }
}

PeerRanking.propTypes = {
  countries: PropTypes.array.isRequired,
  submitRankings: PropTypes.func.isRequired,
  requestSent: PropTypes.bool,
};

export default PeerRanking;
